<div class="video_container">
  <div class="video_wrapper">
    <video 
      on:contextmenu|preventDefault
      controlslist="nodownload" 
      controls 
      poster="https://staticmedia.usefulbots.com/file/t_1/AI-Blindside-2025.jpg"
      playsinline
    >
      <source src="https://staticmedia.usefulbots.com/file/h_720/AI-Blindside-2025.mp4" type="video/mp4">
      <track 
        kind="captions" 
        src="https://staticmedia.usefulbots.com/file/captions/AI-Blindside-2025.vtt" 
        label="English captions" 
        srclang="en" 
        default
      >
      Your browser does not support the video tag.
    </video>
  </div>
</div>

<style>
  .video_container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    background: var(--color-card-bg);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }

  .video_wrapper {
    position: relative;
    width: min(100%, 100vh);
    height: min(100%, 100vh);
    margin: 0 auto;
  }

  .video_wrapper video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style> 